// extracted by mini-css-extract-plugin
module.exports = {"eco_anchor":"EcoAnchor_eco_anchor__CDHyp"};